import View from "../framework/view";
import template from "../../pugc/practichord";
import Server from "../server";

export default class PractichordView extends View {

    static classname = "practichord-view";

    private server = Server.instance();

    private token : string | undefined | false = undefined;

    constructor() {
        super(PractichordView.classname);
        this.setup();
    }

    async setup() {
        const result = await this.server.getPractichordToken();
        // @ts-ignore
        this.token = result.token || false;
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            token: this.token
        }

        const out = this.pug(template, data);
        return out;
    }

}
